import { tenantModel } from "../models";

export const Tenanthelpers = () => {

    const CreateTenantModel = (tenantItem) => {
        return new tenantModel(
            tenantItem.TenantId,
            tenantItem.OwnerId,
            tenantItem.Name,
            tenantItem.Identifier,
            tenantItem.IsReadOnly,
            tenantItem.IsDisabled,
            tenantItem.IsDeleted,
            tenantItem.StatusDate,
            tenantItem.VatNumber,
            tenantItem.AddrStreetName,
            tenantItem.AddrStreetNumber,
            tenantItem.AddrCity,
            tenantItem.AddrProvince,
            tenantItem.AddrZipCode,
            tenantItem.AddrCountry,
            tenantItem.AddrFull,
            tenantItem.Classifier
        );
    }
    const ProcessRawTenantData = (rawTenantItem) => {
        try {            
            var addrStreetName = "";
            var addrStreetNumber = "";
            var addrCity = "";
            var addrProvince = "";
            var addrZipCode = "";
            var addrCountry = "";
            var addrFull = "";
            
            const itemId = rawTenantItem.id;
            const taxId = rawTenantItem.identifier.taxId;
            const itemName = rawTenantItem.details.description;
            const vatNumber = rawTenantItem.identifier.vatNumber;
            const classifier = rawTenantItem.details.classifier;
            const addresses = rawTenantItem.details.addresses;
            
            for (let address of addresses) {
                if (address.types[0] === "REGISTERED_OFFICE") {
                    addrStreetName = address.streetName;
                    addrStreetNumber = address.streetNumber;
                    addrCity = address.city;
                    addrProvince = address.province;
                    addrZipCode = address.zipCode;
                    addrCountry = address.country;
                    addrFull = address.fullAddress;
                }
            }
    
            return {
                tenantId: itemId,
                name: itemName,
                identifier: taxId,
                vatNumber: vatNumber,
                addrStreetName: addrStreetName || addresses[0].streetName,
                addrStreetNumber: addrStreetNumber || addresses[0].streetNumber,
                addrCity: addrCity || addresses[0].city,
                addrProvince: addrProvince || addresses[0].province,
                addrZipCode: addrZipCode || addresses[0].zipCode, 
                addrCountry: addrCountry || addresses[0].country,
                addrFull: addrFull || addresses[0].fullAddress,
                classifier: classifier,
            }
        } catch (error) {
            throw new Error("Errore durante l'elaborazione dei dati del tenant: " + error.message);
        }
    }

    return {
        CreateTenantModel,
        ProcessRawTenantData
    }
}